import store from "../../app/store";
import products from "../../app/products";
import Evented from "../../app/Evented";
import utils from "../../app/utils";
import TileRadarLayer from "../radar/TileRadarLayer";
import scope from "../../app/rootScope";
import SatCalendar from "../radar/RadarCalendar";
import map from "../../app/map";
import TimeSliderView from "../../ui/TimeSliderView";
import PreloadedTimeSliderView from "../../ui/PreloadedTimeSliderView";
import SatelliteTimeSliderController from "./SatelliteTimeSliderController";
import TileSatLayer from "./TileSatLayer";

import "../../../../maps-frontend/assets/css/plugins/satellite/satellite.scss";
import satellitehtml from "../../../../maps-frontend/modules/templates/plugins/satellite/satellite.pug";
import broadcast from "../../app/broadcast";
import satLayer from "./tileSatLayerIntance";
import SelectView from "../../ui/SelectView";
import ModelSwitchController from "../../app/ModelSwitchController";
import SatRangeSwitchController from "./SatRangeSwitchController";
import RangeView from "../../ui/RangeView";
import rootScope from "../../app/rootScope";
import RangeListView from "../../ui/RangeListView";


const productSat=products.satellite,
    SatEvented = Evented.instance({
        ident: "satellite"
    });


let satTimeSliderController = null,
    rangeTimeSwitchController = null,
    updateTimeSatellite,
    tsFiveMinutes = 5 * utils.tsMinute,
    intervalRefreshID = null,
    satParams = null,
    prevValueIsolines = null;
    // satLayer = new TileSatLayer();
// "https://goya.ogimet.com/cgi-bin/sat_otf?z={z}&x={x}&y={y}&ext=jpeg&coastlines=false&type=ir&utime=1656486000"
    // satLayer = new TileRadarLayer( scope.tileServer +'/img/foreground/gray/{z}/{x}/{y}'+(scope.isRetina ? "@2x" : "")+'.png');


function updateSatelliteCalendar(minifest) {
    productSat.minifest = minifest;
    let ts = store.get("satelliteTimestamp")
        , remainTime = 0;

    if (productSat.calendar)
        remainTime = productSat.calendar.end - ts;

    let calendar = productSat.calendar = SatCalendar.instance({
        minifestFile: minifest,
        premium: store.get("premium"),
        step: utils.tsMinute * 5,
    })
    , start = calendar.start
    , end = calendar.end;

    store.set("satelliteCalendar", productSat.calendar);

    if (ts > end || ts < start)
        store.set("satelliteTimestamp", utils.bound(ts, start, end));

}

let firstTime = true;

function enableSatelliteLayer(){

    // productSat.moveTs(-14);
    satLayer.init(satParams);
    satLayer.addTo(map);
    if (satLayer.failed) {
        console.error("It seems that sat failed. ");
        return void store.set("overlay", "wind");
    }

    if (firstTime) {
        store.on("satelliteTimestamp",
            function (ts) {
                satLayer.timestampChanged(ts);
            }
        );
        firstTime = false;
    }

    // productSat.moveTs(-14);
    // satLayer.preload(15);
    // broadcast.on("preloadedtiles", function() {
    //     satTimeSliderController.startAnimation(14);
    // });

}


function loadedMinifest(response) {
    const minifest = response.data;
    if(updateTimeSatellite !== minifest.generated) {
        updateSatelliteCalendar(minifest);
        updateTimeSatellite = minifest.generated;
    }
}

function loadMinifestError(e) {
    console.error("satelliteCalendar", "Unable to create cal from minifest", e)
}

function loadMinifest() {
    productSat.loadMinifest(true).then(loadedMinifest).catch(loadMinifestError)
}


SatEvented.on("open", function() {

        if (!satTimeSliderController) {
            const timeSliderElement = document.querySelector("#controles_satellite");
            if (timeSliderElement) {
                const timeSliderView = new PreloadedTimeSliderView(timeSliderElement);
                satTimeSliderController = new SatelliteTimeSliderController(timeSliderView);
            }
        }
        if (!rangeTimeSwitchController){
            const rangeTimeSwitchElement = document.querySelector("#comborangosat");
            if (rangeTimeSwitchElement) {
                const rangeTimeSwitchView = new RangeListView(rangeTimeSwitchElement);
                rangeTimeSwitchController = new SatRangeSwitchController(rangeTimeSwitchView);
            }
        }
        else
            rangeTimeSwitchController.addElements();

        productSat.loadMinifest().then(loadedMinifest).then(enableSatelliteLayer).catch(loadMinifestError);
        if (!intervalRefreshID)
            intervalRefreshID = setInterval(loadMinifest, tsFiveMinutes);
    }
)

SatEvented.on("close", function (){
        map.removeLayer.call(map, satLayer);
        updateTimeSatellite=null;
    }
)

SatEvented.on("paramsChanged", function(params){
        satLayer.overlayChanged(params.overlay);
    }
)


export const plugincode={html: satellitehtml({
        domain: rootScope.resourcesServer
    })}; //radarcss;

export default {

    redraw: function () {

    },
    onopen: function (params) {
        satParams = params;
        SatEvented.emit("open");
        prevValueIsolines = store.get("isolines");
        store.set("isolines", "off", { doNotStore: true });
    },
    paramsChanged: function (params){
        // console.info("sat params changed");
        // console.info(params);
        SatEvented.emit("paramsChanged", params);
    },
    onclose: function () {
        if(prevValueIsolines)
            store.set("isolines", prevValueIsolines);
        SatEvented.emit("close");
    }
}
